import { render, staticRenderFns } from "./LoadingError.vue?vue&type=template&id=3513ef16"
import script from "./LoadingError.vue?vue&type=script&lang=ts"
export * from "./LoadingError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports